var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{attrs:{"href":_vm.link,"target":"_blank","rel":"noopener noreferrer"}},[_c('img',{class:{'img-active': _vm.zoneIsActive, 'img-deactive': _vm.zoneNotActive},style:(_vm.compDelay),attrs:{"src":_vm.image}})])])}
var staticRenderFns = []

export { render, staticRenderFns }